/**
 * AiTab queries
 */
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'

export const userAIfilesQuery = gql`
  query GetUserFilesAiGenerated {
    images: getUserFilesAiGenerated {
      id
      fileUrl
      type
      size {
        width
        height
      }
      name: fileName
      fileCopyId: file_copy_id
    }
  }
`
export const deleteFileMutation = graphql(
  gql`
    mutation deleteImage($fileId: Int!) {
      deleteAiGeneratedUserFile(fileId: $fileId) {
        message
      }
    }
  `,
  {
    name: 'deleteFile'
  }
)

export const copyAiImageMutation = graphql(
  gql`
    mutation copyAiGeneratedFileToUserFiles($fileId: Int!) {
      copyAiGeneratedFileToUserFiles(fileId: $fileId) {
        id
      }
    }
  `,
  {
    name: 'copyAiGeneratedFileToUserFiles'
  }
)

export const initiateAIRequestMutation = graphql(
  gql`
    mutation initiateAIRequest($token: String!) {
      initiateAIRequest(token: $token) {
        message
      }
    }
  `,
  {
    name: 'initiateAIRequest'
  }
)

export const sendAIRequestMutation = graphql(
  gql`
    mutation sendAIRequest($text: String!, $token: String!) {
      images: sendAIRequest(text: $text, token: $token)
    }
  `,
  {
    name: 'sendAIRequest'
  }
)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/AiTab/data.ts